'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';

import { isNewChatShortcut } from '@/lib/global-shortcuts';

export const NEW_CHAT_EVENT = 'pitchcrow:new-chat';

/**
 * ⌘⇧O anywhere in the app starts a new Home chat. On Home itself the screen
 * handles the event in place (no navigation); elsewhere we route there.
 */
export function GlobalShortcuts() {
  const router = useRouter();
  const pathname = usePathname();
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!isNewChatShortcut(event)) return;
      event.preventDefault();
      if (pathname === '/' || pathname.startsWith('/chat/')) {
        window.dispatchEvent(new Event(NEW_CHAT_EVENT));
        return;
      }
      router.push('/');
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [pathname, router]);
  return null;
}
